import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { BASE_URL, BASE_IMAGE_URL } from "../../service/apiConfig";
import Parser from "html-react-parser";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  Checkbox,
  Row,
  Col,
} from "antd";
import moment from "moment";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import locationTourApi from "../../service/locationTourService";
// import eventServiceApi from "../../service/locationserviceService";
import eventServiceApi from "../../service/eventService";
import provinceApi from "../../service/provinceService";
import translateApi from "../../service/translateService";
import eventCategoryApi from "../../service/eventCategoriesService";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
// import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./management.css";
import draftToHtml from "draftjs-to-html";
import MapManagement from "./MapManagement";
import { useSelector } from "react-redux";
// import htmlToDraft from "html-to-draftjs";
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';

const { Option } = Select;
const  months = [1,2,3,4,5,6,7,8,9,10,11,12] 
export default function ManagementPage() {
  const deepEqual = isEqual;
  const [contentId, setContentId] = useState(0);
  const [provinceId, setProvinceId] = useState(0);
  const currentLocation = useSelector((state) => state.currentLocation);

  const [isShowUpdateService, setIsShowUpdateService] = useState(false);

  const [listProvince, setListProvince] = useState([]);

  const [listCountry, setListCountry] = useState([]);
  const [listEventCategory, setListServiceCategory] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListServiceSubmit, setFileListServiceSubmit] = useState([]);
  const [fileListEventSubmit, setFileListEventSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [eventData, setEventData] = useState();

  const { id } = useParams();
  const [form] = Form.useForm();
  const [formService] = Form.useForm();
  
  const [language, setLanguage] = useState("vi");
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [dataTranslate, setDataTranslate] = useState();
  const [dataChange, setDataChange] = useState(true);
  const [lastData, setLastData] = useState({});
  const [instroductionContent, setInstroductionContent] = useState("");
  const [nameData, setNamedata] = useState("");
  const [nickNameData, setNickNameData] = useState("");
  const [desData, setDesData] = useState("");

  const [centerMap, setCenterMap] = useState({
    lat: "",
    lng: "",
  });

  const [editorStateInstroduction, setEditorStateInstroduction] = useState(
    () => {
      const blocksFromHTML = convertFromHTML(instroductionContent);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
  );

  useEffect(() => {
    getAllProvince();
  }, []);

  const onEditorStateChangeInstroduction = (editorState) => {
    setEditorStateInstroduction(editorState);
  };

  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const onLocationChange = (location) => {
    setDataChange(true)
    formService.setFieldsValue({
      latitude:location.lat,
      longitude:location.lng,
    });
  }

  const getAllProvince = () => {
    provinceApi.getAll().then((res) => {
      setListProvince(res.data);
    });
  };

  const deleteProvince = () => {
    provinceApi.delete(provinceId).then((res) => {
      notification.success({ message: `Delete province success` });
      getAllProvince();
      setOpenDeleteDialog(false);
    });
  };

  const onChangeName = (value) => {
    setNamedata(value.target.value);
  };

  const onChangeNickName = (value) => {
    setNickNameData(value.target.value);
  };

  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };

  const openModalService = (id) => {
    console.log(121, id);
    setContentId(id);
    setProvinceId(id);
    getCountry();
    if (id) {
      provinceApi.getById(id).then((res) => {
        console.log(res);
        const pictureFilenameParse =
        res.data.pictureFilename != null && res.data.pictureFilename != ""
          ? JSON.parse(res.data.pictureFilename)
          : [];
        const files = [];
        const filesSubmit = [];
        if (pictureFilenameParse.length > 0) {
          pictureFilenameParse.forEach((item) => {
            files.push({ url: BASE_IMAGE_URL + item });
            filesSubmit.push(item);
          });
        }

        setFileListService(files);
        setFileListEventSubmit(filesSubmit);
        setDesData(res.data.description);
        setNickNameData(res.data.nickName);
        setNamedata(res.data.name);
        setCenterMap({
          lng: res.data.longitude,
          lat: res.data.latitude,
        });
        setEventData(res.data);
        formService.setFieldsValue({
          name: res.data.name,
          code: res.data.code,
          countryId: res.data.country_id,
          longitude: res.data.longitude,
          latitude: res.data.latitude,
          bestMonth: res.data.bestMonth,
          timezone: res.data.timezone,
          currency: res.data.currency,
          area: res.data.area,
          foundedYear: res.data.foundedYear,
          population: res.data.population,
          populationAtDate: res.data.populationAtDate,
          description: res.data.description,
          nickName: res.data.nickName,
        });
        setIsShowUpdateService(true);
      });
    }
  };

  const onCloseModalService = () => {
    setIsShowUpdateService(false);
    setFileListService([]);
    setLanguage("vi");
    setFileListEventSubmit([]);
    onResetForm()
    setProvinceId(0);
    setEventData(null);
    setCenterMap('')
  };

  const getCountry = () => {
    countriesApi.getAll().then((response) => {
      setListCountry(response.data);
      form.setFieldsValue({ countryId: response.data[0].id });
      formService.setFieldsValue({ countryId: response.data[0].id });
    });
  };
  const getEventCategories = () => {
    eventCategoryApi.getAll().then((response) => {
      setListServiceCategory(response.data);
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 30 },
  };

  const openDeleteService = (id) => {
    setProvinceId(id);
    setOpenDeleteDialog(true);
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex, placeHolderSearch) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm ${placeHolderSearch}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Đặt lại
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Lọc
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
    get(record, dataIndex)
    .toString()
    .toLowerCase()
    .includes(value.toLowerCase()),
      // record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      // searchedColumn === dataIndex ? (
        isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columnsService = [
    {
      title: "Tỉnh Thành",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name", "Tỉnh Thành"),
    },   
    {
      title: "Quốc Gia",
      dataIndex: "countryName",
      key: "countryName",
      ...getColumnSearchProps("countryName", "Quốc Gia"),
    },
    {
      title: "Năm thành lập",
      dataIndex: "foundedYear",
      key: "foundedYear",      
    },    
    {
      title: "Diện tích",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Dân số",
      dataIndex: "population",
      key: "population",
    },
    // {
    //   title: "Mô tả",
    //   dataIndex: "description",
    //   key: "description",
    //   ...getColumnSearchProps("description"),
    //   // render: (text) => <Typography.Text style={{width: 300}} >{text}</Typography.Text>,
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalService(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];

  const onResetForm = () => {
    formService.setFieldsValue({
      name: "",
      code: "",
      countryId: null,
      longitude: "",
      latitude: "",
      nickName: "",
      description: "",
      timezone: "",
      area: "",
      bestMonth: "",
      population: "",
      foundedYear: "",
    });
  }
  const onFinishHandleService = (values) => {
    values.pictureFilename = fileListEventSubmit;
    // values.bestMonth = JSON.stringify(values?.bestMonth)
    if (provinceId !== 0) {
      if (language === "vi") {
        provinceApi.updateById(provinceId, values).then((res) => {        
          notification.success({ message: "Tạo Tỉnh Thành Thành Công" });
          let newData = {}
          newData[language] = {}
          newData[language].name = formService.getFieldValue("name")
          newData[language].nickName = formService.getFieldValue("nickName")
          newData[language].description = formService.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllProvince();
          onCloseModalService();
        });
      } else if (language === "en") {
        const temp = {
          en: {
            name: values.name,
            nickName: values.nickName,
            description: values.description,
          },
        };
        const data = { textTranslate: JSON.stringify(temp) };
        provinceApi.updateById(provinceId, data).then((res) => {
          notification.success({ message: "Tạo Tỉnh Thành Thành Công" });
          getAllProvince();
          onCloseModalService();
        });
      } else {
        var temp={}
        temp[language] =
         {
          name: values.name,
          nickName: values.nickName,
          description: values.description,
         }
        
        const data = { textTranslate: JSON.stringify(temp) };
        provinceApi.updateById(provinceId, data).then((res) => {
          notification.success({ message: "Cập Nhật Tỉnh Thành Thành Công" });
          let newData = {}
          newData[language] = {}
          newData[language].name = formService.getFieldValue("name")
          newData[language].nickName = formService.getFieldValue("nickName")
          newData[language].description = formService.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllProvince();
        });
      }
      // provinceApi.updateById(provinceId, values).then((res) => {
      //   notification.success({ message: "Cập Nhật Tỉnh Thành Thành Công" });
      //   // onCloseModalService();
      //   getAllProvince();
      //   onCloseModalService();
      // });
    } else {
      provinceApi.create(values).then((res) => {
        notification.success({ message: "Tạo Tỉnh Thành Thành Công" });
        onResetForm()
        getAllProvince();
        onCloseModalService();
      });
    }
  };
  const onSelectLanguage = (value) => {
    setDataChange(true);
    onHandleTranslate(contentId, value);
    setLanguage(value);
  };

  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      name: nameData,
      nickName: nickNameData,
      description: desData,
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang : language,
      type: "province",
      id: id,
    };

    translateApi.translate(data).then((res) => {
      const textTranslate = res.data;
      console.log("textTranslate", textTranslate);
      if (textTranslate.length > 0) {
        setLoadingTranslate(false);
        const newdata = [];
        textTranslate.map((e) => {
          if (e.language == language) {
            formService.setFieldsValue({
              name: e.name,
              nickName: e.nickName,
              description: e.description,
            });
          }
        });
        console.log("newdata", newdata);
      } else {
        setLoadingTranslate(false);
        setDataTranslate(dataTranslate);
        let newFormData = {
          name: res.data.name,
          nickName: res.data.nickName,
          description: res.data.description,
        }
        setDataChange(false)
        if (!deepEqual(newFormData, lastData[data.language])){
          setDataChange(true)
        }
        formService.setFieldsValue({
          name: res.data.name,
          nickName: res.data.nickName,
          description: res.data.description,
        });
      }
    });
    //   const textTranslate = res.data;
    //   setLoadingTranslate(false);
    //   formService.setFieldsValue({
    //     name: textTranslate.name,
    //     description: textTranslate.description,
    //   });
    // });
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm Ảnh
      </div>
    </div>
  );

  const handleChangeService = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      onFormValueChange()
      setFileListService(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }

      // setFileListServiceSubmit(urlArraySubmit);
      setFileListEventSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    return isJpgOrPng;
  };

  // formService.setFieldsValue(
  //   {
  //     latitude:
  //       currentLocation?.latitude != ""
  //         ? currentLocation?.latitude
  //         : eventData?.latitude,
  //     longitude:
  //       currentLocation?.longitude != ""
  //         ? currentLocation?.longitude
  //         : eventData?.longitude,
  //   },
  //   []
  // );

 const onChange = (checkedValues) => {

 }

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Quản Lý Tỉnh Thành
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateService(true);
              getEventCategories();
              getCountry();
            }}
          >
            Tạo Tỉnh Thành
          </Button>
        }
      >
        <Table columns={columnsService} dataSource={listProvince} bordered />

        <Modal
          title={provinceId !== 0 ? "Cập Nhật Tỉnh Thành" : "Tạo Tỉnh Thành"}
          visible={isShowUpdateService}
          // onOk={handleOkTour}
          width="80%"
          onCancel={() => {
            setProvinceId(0);
            onCloseModalService();
            setFileListServiceSubmit([]);
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalService();
                }}
              >
                {/* Close */}
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled = {!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around" >
          <Col span={12}>
          {contentId !== 0 && (
                <Row justify="end">
                  <Select
                    onChange={onSelectLanguage}
                    defaultValue="vi"
                    value={language}
                  >
                  <Option value="vi">Tiếng Việt</Option>
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="zh-CN">Chinese</Option>
                  <Option value="ko">Korean</Option>
                  <Option value="de">German</Option>
                  </Select>
                  <Button
                    type="primary"
                    onClick={() => {
                      onHandleTranslate(contentId);
                    }}
                    loading={loadingTranslate}
                  >
                    Dịch
                  </Button>
                </Row>
              )}
          
              <Upload
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={true}
                multiple={true}
                action={BASE_IMAGE_URL + "/api/upload"}
                beforeUpload={beforeUpload}
                onChange={handleChangeService}
                fileList={fileListService}
                disabled={language != "vi"}
              >
                {uploadButton}
              </Upload>
          
              <Form
                {...layout}
                form={formService}
                name="CU-tour"
                onFinish={onFinishHandleService}
                onValuesChange = {onFormValueChange}
              >
                <Form.Item
                  name="name"
                  label="Tên"
                  rules={[{ required: true }]}
                >
                  <Input size="large" onChange={onChangeName}  />
                </Form.Item>
                <Form.Item
                  name="nickName"
                  label="Tên gọi khác"
                  rules={[{ required: false }]}
                >
                  <Input size="large" onChange={onChangeNickName}/>
                </Form.Item>                
                {/* <Form.Item name="code" label="Mã Vùng">
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item> */}
                <Form.Item name="countryId" label="Quốc Gia">
                  <Select disabled={ language!='vi' }>
                    {listCountry?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.countryName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                
                <Form.Item
                  name="area"
                  label="Diện tích"
                  rules={[{ required: false }]}
                >
                  <Input placeholder="Km&sup2;" size="large" disabled={ language!='vi' }/>
                </Form.Item>
                

                <Form.Item
                  name="population"
                  label="Dân số"
                  rules={[{ required: false }]}
                >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>

                <Form.Item
                  name="foundedYear"
                  label="Thành lập"
                  rules={[{ required: false }]}
                >
                  <Input size="large" disabled={ language!='vi' } />
                </Form.Item>
                <Form.Item
                  name="bestMonth"
                  label="Tháng nên tham quan"
                >
                   <Checkbox.Group
                    style={{
                      width: '100%',
                    }}
                    onChange={onChange}
                    >                      
                        {
                          months.map((item, index) => {                      
                              return(<Row>
                                <Col>
                                <Checkbox value={item}>Tháng {item}</Checkbox>                      
                                </Col>      
                              </Row>)
                          })
                        }                       
                    </Checkbox.Group>
                  {/* <Input.Checkbox size="large" disabled={ language!='vi' }/> */}
                </Form.Item>                
                <Form.Item
                  name="timezone"
                  label="Múi giờ"
                  rules={[{ required: false }]}
                >
                  <Input size="large" placeholder="GMT +07:00" defaultValue="GMT +07:00" disabled={ language!='vi' }/>
                </Form.Item>

                <Form.Item
                  name="latitude"
                  label="Latitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>
                <Form.Item
                  name="longitude"
                  label="Longitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>
                <Form.Item
                  name="description"
                  label="Mô tả"
                  rules={[{ required: false }]}
                >
                   <Input.TextArea rows={15} size="large" onChange={onChangeDes} />
                </Form.Item>                
              </Form>
            </Col>
            <Col span={10}>
              <MapManagement location={centerMap} onChange = {onLocationChange} ></MapManagement>
            </Col>
          </Row>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteProvince}
        onCancel={() => {
          setProvinceId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa Tỉnh Thành`}
      >
        Bạn có chắc muốn xóa Tỉnh Thành này?
      </Modal>
    </>
  );
}
